import { GLOBAL_PLATFORM_NAME } from './globals';

export const ERROR_AUTH_NO_TOKEN = 'auth_no_token';
export const ERROR_AUTH_BAD_TOKEN = 'auth_bad_token';
export const ERROR_AUTH_EXPIRED_TOKEN = 'auth_expired_token';
export const ERROR_PERM_NO_ADMIN_ACCESS = 'perm_role_teacher_admin'; // PERM_ROLE_TEACHER_ADMIN
export const ERROR_PERM_NO_VELA_ACCESS = 'perm_no_vela_access';
export const ERROR_ACCOUNT_INACTIVE = 'account_inactive';
export const ERROR_INVITE_INVALID = 'invite_invalid';
export const ERROR_INVITE_MISSING_ID = 'invite_missing_id';

export const errorHumanReadable = (errorCode) => {
  switch (errorCode) {
    case ERROR_AUTH_NO_TOKEN:
      return 'Something went wrong, please try again. No token.';
    case ERROR_AUTH_BAD_TOKEN:
      return 'Something went wrong, please try again. Bad token.';
    case ERROR_AUTH_EXPIRED_TOKEN:
      return 'Your session expired.';
    case ERROR_PERM_NO_ADMIN_ACCESS:
      return `You don't have permission to access ${GLOBAL_PLATFORM_NAME} Admin.`;
    case ERROR_PERM_NO_VELA_ACCESS:
      return "You don't have permission to access VELA.";
    case ERROR_ACCOUNT_INACTIVE:
      return "You're account is inactive.";
    case ERROR_INVITE_INVALID:
      return 'Invalid Invitation. Request a new Invitation.';
    case ERROR_INVITE_MISSING_ID:
      return 'Missing Invitation ID. Request a new Invitation.';
    default:
      return errorCode;
  }
};
